import SingleChoiceAttributeView from "./SingleChoiceAttribute/SingleChoiceAttributeView";

const customAttributeViews = {
    single_choice: SingleChoiceAttributeView,
};

export function resolveCustomAttributeView(type) {
    return customAttributeViews[type];
}
